import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckinSelectSubHeaderComponent } from './checkin-select-sub-header.component';
import { RouterModule } from '@angular/router';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [CheckinSelectSubHeaderComponent],
  imports: [CommonModule, StaticMsgModule, RouterModule],
  exports: [CheckinSelectSubHeaderComponent],
})
export class CheckinSelectSubHeaderModule {}
